var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line;

var printPreservingEmptyLines = require('./print-preserving-empty-lines');

var Block = {
  print: function print(_ref) {
    var node = _ref.node,
        options = _ref.options,
        path = _ref.path,
        _print = _ref.print;

    // if block is empty, just return the pair of braces
    if (node.statements.length === 0 && !node.comments) {
      return '{}';
    }

    var parts = ['{', indent(line), indent(printPreservingEmptyLines(path, 'statements', options, _print))];

    if (node.comments) {
      var first = true;
      path.each(function (commentPath) {
        if (first) {
          first = false;
        } else {
          parts.push(indent(line));
        }

        var comment = commentPath.getValue();

        if (comment.trailing || comment.leading) {
          return;
        }

        comment.printed = true;
        parts.push(options.printer.printComment(commentPath));
      }, 'comments');
    }

    parts.push(line);
    parts.push('}');
    return concat(parts);
  }
};
module.exports = Block;